var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32.2646,
    height: 33.7334,
    rx: 6.5,
    fill: "white",
    stroke: "#00A850"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_236)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1016 12.0062H19.7826L21.0768 14.1509H23.7435C23.8854 14.1509 24.0013 14.2624 24.0013 14.3908V22.7614C24.0013 22.8898 23.8828 23.0013 23.7435 23.0013H8.25781C8.11979 23.0001 8 22.8923 8 22.7614V14.3908C8 14.2587 8.11589 14.1509 8.25781 14.1509H9.45703V13.3815H10.9388V14.1509H12.5482C12.8828 13.5354 13.2174 12.921 13.5521 12.3055C13.7552 11.931 13.6432 12.0062 14.1016 12.0062ZM22.332 15.2112C22.7565 15.2112 23.1003 15.5311 23.1003 15.9261C23.1003 16.3211 22.7565 16.641 22.332 16.641C21.9076 16.641 21.5638 16.3211 21.5638 15.9261C21.5651 15.5311 21.9089 15.2112 22.332 15.2112ZM16.6771 16.0436C17.9622 16.0436 19.0052 17.0142 19.0052 18.2102C19.0052 19.4061 17.9622 20.3767 16.6771 20.3767C15.3919 20.3767 14.349 19.4061 14.349 18.2102C14.349 17.0142 15.3919 16.0436 16.6771 16.0436ZM16.6771 14.6332C18.8008 14.6332 20.5221 16.2351 20.5221 18.2114C20.5221 20.1865 18.8008 21.7896 16.6771 21.7896C14.5547 21.7896 12.832 20.1865 12.832 18.2114C12.8333 16.2351 14.5547 14.6332 16.6771 14.6332Z",
    fill: "#00A850"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 11,
    fill: "white",
    transform: "translate(8 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.56ca93edd321019741905433c8fa15f2.svg";
export { ForwardRef as ReactComponent };